import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { UiModule } from '@ov-suite/ui';
import { PickSheetComponent } from '../list/pick-list.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatCardModule, UiModule],
  declarations: [PickSheetComponent],
  exports: [PickSheetComponent],
})
export class PickSheetModule {}
